import t from 'tcomb';
import Style_Distance from '../Style_Distance';
import Color from '../Color';

// Stili delle componenti
const Text_Align = t.enums.of('left right center justify'.split(' '));
const Font_family = t.enums.of(['Georgia', 'Tahoma', 'Courier New', 'Verdana']);
const Text_Style_Size = t.enums.of(['small', 'medium', 'large']);

const Text_Style = t.struct({
  size: t.maybe(Text_Style_Size),
  'text-align': t.maybe(Text_Align),
  color: t.maybe(Color),
  'background-color': t.maybe(Color),
  padding: t.maybe(Style_Distance),
  'font-family': t.maybe(Font_family)
}, 'Text_Style');

module.exports = Text_Style;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/style/Text_Style.js
 **/